import { render, staticRenderFns } from "./ArticleHeaderDownloadButton.vue?vue&type=template&id=1372cf9a&scoped=true"
import script from "./ArticleHeaderDownloadButton.vue?vue&type=script&lang=js"
export * from "./ArticleHeaderDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./ArticleHeaderDownloadButton.vue?vue&type=style&index=0&id=1372cf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372cf9a",
  null
  
)

export default component.exports